import React from 'react';
import { Button, Modal } from 'antd';

import { RESTART_CIRCLE_BLUE_ICON } from '../../config/media';
import Wrapper from './style';

const ApplyChangesConfirmation = ({
    isVisible,
    handleApply,
    handleClose
}) => {
    return (
        <Modal
            visible={isVisible}
            footer={null}
            onCancel={handleClose}
        >
            <Wrapper>
                <div className="apply-confirmation">
                    <img src={RESTART_CIRCLE_BLUE_ICON} className="apply-restart-icon" alt="apply_changes" />
                    <div className="title">Apply changes</div>
                </div>
                <div className="apply-confirm-info">Applying the changes now may cause a short disruption to your exchange service.</div>
                <div className="apply-confirm-info">Do you want to apply the changes to the live exchanges now?</div>
                <div className="btn-wrapper">
                    <Button
                        type="primary"
                        className="apply-btn"
                        onClick={handleClose}
                    >
                        Apply later
                    </Button>
                    <div className="separator"></div>
                    <Button
                        type="primary"
                        className="apply-btn"
                        onClick={handleApply}
                    >
                        Apply now
                    </Button>
                </div>
            </Wrapper>
        </Modal>
    );
}

export default ApplyChangesConfirmation;
